<template>
    <div></div>
</template>

<script>
export default {
  name: 'auth',
  async created () {
    const token = this.$route.query.auth
    if (token) {
      localStorage.setItem('hduhelp-token', token)
    }
    this.$router.replace('/')
  }
}
</script>